export {
	DesktopOnlyView,
	MobileOnlyView,
	MobileOrTabletView,
	MobileHiddenView,
	TabletOnlyView,
} from './Media';
